import { getSpamTokens } from '../helpers/spam-protection';

const getTokenInput = (name, value) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);

    return input;
};

export default function Form(el, {
    modelHandle,
    recaptchaSiteKey,
    turnstileSiteKey,
}) {
    const form = el.querySelector('form');

    if (!form) return;

    const submit = form.querySelector('[type="submit"]');

    let processing = false;

    function handleSubmit(e) {
        e.preventDefault();

        if (processing) {
            return;
        }

        processing = true;
        submit.setAttribute('disabled', true);

        getSpamTokens({
            recaptchaSiteKey,
            turnstileSiteKey,
            action: modelHandle,
            container: form,
        }).then(({ recaptchaToken, turnstileToken }) => {
            form.appendChild(getTokenInput('recaptchaToken', recaptchaToken));
            form.appendChild(getTokenInput('turnstileToken', turnstileToken));
            form.submit();
        }).catch(err => {
            processing = false;
            submit.removeAttribute('disabled');
            console.error('Spam protection error:', err);
            window.alert('Verification failed. Please try again.');
        });
    }

    form.addEventListener('submit', handleSubmit);
}
